module.exports = {"TXTCLI_Amount":{"id":"TXTCLI_Amount","defaultMessage":"Amount","track":"Amount"}}